import type { FC } from 'react';
import { lazy, Suspense, useContext } from 'react';

import { wizardContext } from '../contexts';
import { EWizardType } from '../types/EWizardType';
import type { SubscriptionTypesContainerProps } from '../types/SubscriptionTypesContainerProps';
import { WizardLoader } from '~/shared/components/WizardLoader';

const SubscriptionContainer = lazy(async () =>
  import(
    /* webpackChunkName: "SubscriptionContainer", webpackPrefetch: true */ './SubscriptionContainer'
  ).then((module) => ({
    default: module.SubscriptionContainer,
  })),
);

const AutoshipContainer = lazy(async () =>
  import(
    /* webpackChunkName: "AutoshipContainer", webpackPrefetch: true */ './AutoshipContainer'
  ).then((module) => ({
    default: module.AutoshipContainer,
  })),
);

export const SubscriptionTypesContainer: FC<SubscriptionTypesContainerProps> = () => {
  const { wizardType, productCode, id } = useContext(wizardContext);

  if (!wizardType) {
    return null;
  }

  return wizardType === EWizardType.Subscription ? (
    <Suspense fallback={<WizardLoader />}>
      <SubscriptionContainer
        key={id}
        product={productCode}
      />
    </Suspense>
  ) : (
    <Suspense fallback={<WizardLoader />}>
      <AutoshipContainer
        key={id}
        product={productCode}
      />
    </Suspense>
  );
};
